module.exports = __webpack_public_path__ + "static/LoginBACK-e4bd706094b508087fa9f0816075b722.jpg";